if (!customElements.get('blackout-product')) {
  customElements.define(
    'blackout-product',
    class BlackoutProduct extends HTMLElement {
      connectedCallback() {
        this.data = JSON.parse(this.querySelector('[data-product-json]').textContent);
        this.mainImage = this.querySelector('[data-main-image]');
        this.galleryBadge = this.querySelector('[data-gallery-badge]');
        this.thumbs = this.querySelector('[data-thumbs]');
        this.priceEl = this.querySelector('[data-price]');
        this.colorLabel = this.querySelector('[data-color-label]');
        this.sizeLabel = this.querySelector('[data-size-label]');
        this.variantIdInput = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitLabel = this.submitButton ? this.submitButton.querySelector('span') : null;

        this.state = {
          color: null,
          size: null,
          images: this.data.media,
          activeImage: 0,
          cartCount: 0,
        };

        this.categorizeMediaByColor();

        this.querySelectorAll('[data-color-input]').forEach((el) => {
          el.addEventListener('change', () => this.onColorChange(el.value));
        });
        this.querySelectorAll('[data-size-input]').forEach((el) => {
          el.addEventListener('change', () => this.onSizeChange(el.value));
        });
        if (this.thumbs) {
          this.thumbs.addEventListener('click', (event) => {
            const thumb = event.target.closest('[data-thumb-index]');
            if (thumb) this.setActiveImage(Number(thumb.dataset.thumbIndex));
          });
        }

        const checkedColor = this.querySelector('[data-color-input]:checked');
        const checkedSize = this.querySelector('[data-size-input]:checked');
        this.state.color = checkedColor ? checkedColor.value : null;
        this.state.size = checkedSize ? checkedSize.value : null;

        this.updateGalleryForColor();
        this.updateVariant();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.onCartAdded());
        }
      }

      onColorChange(color) {
        this.state.color = color;
        if (this.colorLabel) this.colorLabel.textContent = color;
        this.updateGalleryForColor();
        this.updateVariant();
      }

      onSizeChange(size) {
        this.state.size = size;
        if (this.sizeLabel) this.sizeLabel.textContent = size;
        this.updateVariant();
      }

      // Matches each media item's alt text to the longest color name it contains, so that
      // e.g. "White" doesn't also match media tagged "White Sand".
      categorizeMediaByColor() {
        const colors = this.data.colorValues || [];
        this.data.media.forEach((media) => {
          const altLower = (media.alt || '').toLowerCase();
          let bestMatch = null;
          colors.forEach((color) => {
            const colorLower = color.toLowerCase();
            if (altLower.includes(colorLower) && (!bestMatch || colorLower.length > bestMatch.length)) {
              bestMatch = colorLower;
            }
          });
          media.matchedColor = bestMatch;
        });
      }

      updateGalleryForColor() {
        const color = this.state.color;
        let images = this.data.media;
        if (color) {
          const colorLower = color.toLowerCase();
          const filtered = this.data.media.filter((media) => media.matchedColor === colorLower);
          if (filtered.length) images = filtered;
        }
        this.state.images = images;
        this.renderThumbs();
        this.setActiveImage(0);
      }

      renderThumbs() {
        if (!this.thumbs) return;
        this.thumbs.innerHTML = this.state.images
          .slice(0, 4)
          .map(
            (media, index) => `
              <div class="bo-gallery__thumb" data-thumb-index="${index}">
                <img src="${media.src}" alt="" loading="lazy">
              </div>
            `
          )
          .join('');
      }

      setActiveImage(index) {
        const images = this.state.images;
        if (!images.length) return;
        this.state.activeImage = Math.max(0, Math.min(index, images.length - 1));
        const media = images[this.state.activeImage];

        if (this.mainImage) this.mainImage.src = media.src;
        if (this.galleryBadge) {
          const current = String(this.state.activeImage + 1).padStart(2, '0');
          const total = String(images.length).padStart(2, '0');
          this.galleryBadge.textContent = `Fig. ${current} / ${total}`;
        }
        if (this.thumbs) {
          this.thumbs.querySelectorAll('[data-thumb-index]').forEach((el, i) => {
            el.style.opacity = i === this.state.activeImage ? '1' : '0.45';
          });
        }
      }

      updateVariant() {
        const variant = this.data.variants.find(
          (v) =>
            (!this.data.colorOptionName || v.color === this.state.color) &&
            (!this.data.sizeOptionName || v.size === this.state.size)
        );
        if (!variant) return;

        if (this.variantIdInput) {
          this.variantIdInput.value = variant.id;
          this.variantIdInput.disabled = !variant.available;
        }
        if (this.priceEl) this.priceEl.textContent = variant.price;
        if (this.submitButton) {
          this.submitButton.toggleAttribute('disabled', !variant.available);
        }
        if (this.submitLabel && this.state.cartCount === 0) {
          this.submitLabel.textContent = variant.available
            ? this.dataset.labelAdd
            : this.dataset.labelSoldout;
        }
      }

      onCartAdded() {
        this.state.cartCount += 1;
        if (this.submitLabel) {
          this.submitLabel.textContent = `${this.dataset.labelIncart} (${this.state.cartCount}) — ${this.dataset.labelContinue}`;
        }
      }
    }
  );
}
